import * as React from "react";

import {
  PresentationFacet,
  PresentationFacet_PresentationType,
  ResponseFacetValue,
} from "../../model";

import { useProductListController_forFiltering } from "../../providers";

interface FilterOptionControlProps {
  facet: PresentationFacet;
  option: ResponseFacetValue;
  renderExtraLabelSpanSlot?: () => void;
  idPrefix?: string;
}

export const FilterOptionControl: React.FunctionComponent<
  FilterOptionControlProps
> = (props) => {
  const { facet, option, idPrefix } = props;

  const { isOptionSelected } = useProductListController_forFiltering();

  const isSelected = React.useMemo(
    () => isOptionSelected(facet, option),
    [facet, option, isOptionSelected]
  );

  // labels propagate clicks to inputs they're associated with,
  // which then propagates to the parent element,
  // which also catches the initial propagation from the label click,
  // causing it to be called twice.
  // so we stop the default behaviour of label's click,
  // to prevent it passing the event along to its associated input.
  const onLabelClick: React.MouseEventHandler = (event: React.MouseEvent) => {
    event.preventDefault();
  };

  const id = `${idPrefix ? `${idPrefix}-` : ""}${option.id}`;

  return (
    <React.Fragment>
      <input
        type={facet.hasMultiSelection ? "checkbox" : "radio"}
        id={id}
        name={id}
        checked={isSelected}
      />
      <label htmlFor={id} className="name" onClick={onLabelClick}>
        {facet.hasMultiSelection && isSelected && (
          <div className="checkbox-checked-icon"></div>
        )}
        {facet.presentationType ===
          PresentationFacet_PresentationType.colors && (
          <div
            className={`color-swatch color-${option.id}`}
            style={{ background: option.name.toLowerCase() }}
          ></div>
        )}
        {option.name}
        {props.renderExtraLabelSpanSlot
          ? props.renderExtraLabelSpanSlot()
          : null}
      </label>
    </React.Fragment>
  );
};
